function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useContext, useEffect, useId, useRef, useState } from 'react';
import Flicking from '@egjs/react-flicking';
import { AutoPlay } from '@egjs/flicking-plugins';
import { twMerge } from '@stereoagency/tailwind-config';
import { Button, Container, EntryAnimation, Heading } from '../../atoms';
import { useBreakpoint } from '../../hooks';
import { LightArrowLeft, LightArrowRight } from '../../visuals';
import ReactConfigContext from '../../ReactConfigContext';
export default function LogoCarouselSection(param) {
    var title = param.title, cards = param.cards, className = param.className;
    var id = useId();
    var containerRef = useRef(null);
    var flickingRef = useRef(null);
    var _useState = _sliced_to_array(useState(0), 2), currentIndex = _useState[0], setCurrentIndex = _useState[1];
    var _useBreakpoint = useBreakpoint(), minWidth = _useBreakpoint.minWidth, BREAKPOINTS = _useBreakpoint.BREAKPOINTS;
    var _useContext = useContext(ReactConfigContext), _useContext_config = _useContext.config, ImageComponent = _useContext_config.ImageComponent, LinkComponent = _useContext_config.LinkComponent;
    var slidesPerView = minWidth <= BREAKPOINTS.xs ? 1 : minWidth <= BREAKPOINTS.md ? 3 : 6;
    var align = Math.min(slidesPerView, cards.length) < 6 ? 'center' : 'prev';
    var firstIndex = align === 'prev' ? 0 : Math.floor(slidesPerView / 2);
    var canGoBack = currentIndex > firstIndex;
    var canGoForward = currentIndex < cards.length - slidesPerView;
    var handleBack = function handleBack() {
        var _flickingRef_current, _flickingRef_current1;
        if ((_flickingRef_current = flickingRef.current) === null || _flickingRef_current === void 0 ? void 0 : _flickingRef_current.animating) {
            var _flickingRef_current2;
            (_flickingRef_current2 = flickingRef.current) === null || _flickingRef_current2 === void 0 ? void 0 : _flickingRef_current2.stopAnimation();
        }
        (_flickingRef_current1 = flickingRef.current) === null || _flickingRef_current1 === void 0 ? void 0 : _flickingRef_current1.moveTo(Math.max(0, currentIndex - 1));
    };
    var handleWillChange = function handleWillChange(event) {
        setCurrentIndex(event.index);
    };
    var handleForward = function handleForward() {
        var _flickingRef_current, _flickingRef_current1;
        if ((_flickingRef_current = flickingRef.current) === null || _flickingRef_current === void 0 ? void 0 : _flickingRef_current.animating) {
            var _flickingRef_current2;
            (_flickingRef_current2 = flickingRef.current) === null || _flickingRef_current2 === void 0 ? void 0 : _flickingRef_current2.stopAnimation();
        }
        (_flickingRef_current1 = flickingRef.current) === null || _flickingRef_current1 === void 0 ? void 0 : _flickingRef_current1.moveTo(Math.min(cards.length - slidesPerView, currentIndex + 1));
    };
    var sharedFlickingProps = {
        ref: flickingRef,
        horizontal: true,
        bound: true,
        onWillChange: handleWillChange
    };
    var flickingChildren = cards.map(function(card, cardIndex) {
        var innerCardContent = /*#__PURE__*/ React.createElement("div", {
            className: "isolate bg-white p-6 rounded-xl"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "aspect-w-1 aspect-h-1 md:aspect-w-3 md:aspect-h-2"
        }, /*#__PURE__*/ React.createElement(ImageComponent, _object_spread_props(_object_spread({}, card.logo), {
            className: twMerge(card.logo.className, 'w-full h-full object-contain object-center pointer-events-none')
        }))));
        return /*#__PURE__*/ React.createElement("div", {
            key: "card-".concat(id, "-").concat(card.logo.src),
            className: "px-3 w-[60%] sm:w-1/3 lg:w-1/6"
        }, /*#__PURE__*/ React.createElement(EntryAnimation, {
            view: containerRef,
            delay: cardIndex / 20
        }, card.action ? /*#__PURE__*/ React.createElement(LinkComponent, _object_spread({
            draggable: false
        }, card.action), innerCardContent) : innerCardContent));
    });
    useEffect(function() {
        var _ref;
        var _flickingRef_current;
        setCurrentIndex((_ref = (_flickingRef_current = flickingRef.current) === null || _flickingRef_current === void 0 ? void 0 : _flickingRef_current.index) !== null && _ref !== void 0 ? _ref : 0);
    }, [
        align
    ]);
    return /*#__PURE__*/ React.createElement(Container, {
        ref: containerRef,
        name: LogoCarouselSection.name,
        background: "subtle",
        className: twMerge('overflow-hidden', className)
    }, !!title && /*#__PURE__*/ React.createElement(EntryAnimation, {
        view: containerRef,
        className: "mb-7 md:mb-10"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full max-w-md text-center mx-auto"
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h2",
        variant: "h2"
    }, title))), /*#__PURE__*/ React.createElement("div", {
        className: "grid gap-7 grid-cols-1 items-center md:grid-cols-[auto_minmax(0px,1fr)_auto]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "hidden md:block"
    }, /*#__PURE__*/ React.createElement(Button, {
        type: "icon-only",
        variant: "border",
        icon: /*#__PURE__*/ React.createElement(LightArrowLeft, null),
        disabled: !canGoBack,
        onClick: handleBack
    })), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "-m-3"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "md:overflow-hidden"
    }, align === 'prev' && /*#__PURE__*/ React.createElement(Flicking, _object_spread_props(_object_spread({}, sharedFlickingProps), {
        align: "prev",
        plugins: [
            new AutoPlay({
                duration: 3000,
                stopOnHover: true
            })
        ]
    }), flickingChildren), align === 'center' && /*#__PURE__*/ React.createElement(Flicking, _object_spread_props(_object_spread({}, sharedFlickingProps), {
        align: "center",
        plugins: [
            new AutoPlay({
                duration: 3000,
                stopOnHover: true
            })
        ]
    }), flickingChildren)))), /*#__PURE__*/ React.createElement("div", {
        className: "hidden md:block"
    }, /*#__PURE__*/ React.createElement(Button, {
        type: "icon-only",
        variant: "border",
        icon: /*#__PURE__*/ React.createElement(LightArrowRight, null),
        disabled: !canGoForward,
        onClick: handleForward
    }))));
}

//# sourceMappingURL=LogoCarouselSection.js.map